import { CacheRepository } from "../../../decorators/cache.decorator";
import { ItemService } from "../../../util/items/item.service";
import { INGESTION_FIELD_TYPE_ID } from "../data.ingestion.const";
import type { IngestionFieldDefinition } from "../data.ingestion.service";
import { ModalService } from "../../modal/modal.service";
import { Rules } from "../../s25-rule-tree/s25.rule.const";
import type { RuleActionTarget } from "../../../services/rule.tree.service";

export function invalidateIngestionFormRulesFieldCache(ingestionPointId: number, itemService: ItemService): void {
    CacheRepository.invalidateByService("DataIngestionService");
    itemService.criteria("ingestionFieldsAll").invalidateQueries({
        customFilterValue: String(ingestionPointId),
    });
}

export type IngestionShowHideRuleTargetAction = "showField" | "hideField";

export function buildIngestionFieldRuleTarget(fieldDef: IngestionFieldDefinition): RuleActionTarget {
    return {
        itemId: fieldDef.fieldDefinitionId!,
        itemTypeId: INGESTION_FIELD_TYPE_ID,
        itemName: fieldDef.fieldLabel ?? "",
        itemValue: "",
    };
}

export function buildNewIngestionShowHideRule(options: {
    ingestionPointId: number;
    fieldDef: IngestionFieldDefinition;
    targetAction: IngestionShowHideRuleTargetAction;
}): Rules.Rule {
    const fieldTarget = buildIngestionFieldRuleTarget(options.fieldDef);
    const subCategory = String(options.ingestionPointId);
    const actionLabel = options.targetAction === "showField" ? "Show" : "Hide";

    return {
        id: -1 * Math.ceil((Math.random() + 1) * 100000000),
        name: `${actionLabel}: ${options.fieldDef.fieldLabel ?? "Field"}`,
        description: "",
        active: true,
        category: "ingestion",
        subCategory,
        targets: {
            showField: options.targetAction === "showField" ? [fieldTarget] : [],
            hideField: options.targetAction === "hideField" ? [fieldTarget] : [],
        },
        conditions: {
            operator: "and",
            children: [],
        },
        conditionFilterMap: { ingestionFieldsAll: subCategory },
    };
}

export function canAddIngestionShowHideRuleForField(fieldDef: IngestionFieldDefinition): boolean {
    return !!fieldDef.fieldDefinitionId;
}

export function openNewIngestionShowHideRuleModal(options: {
    ingestionPointId: number;
    fieldDef: IngestionFieldDefinition;
    targetAction: IngestionShowHideRuleTargetAction;
    refresh: () => void | Promise<void>;
}): boolean {
    if (!canAddIngestionShowHideRuleForField(options.fieldDef)) {
        return false;
    }

    ModalService.modal("edit-rule", {
        rule: buildNewIngestionShowHideRule(options),
        title: "Create New Rule",
        isNew: true,
        refresh: options.refresh,
    });
    return true;
}
